import * as React from "react";
import Divider from "../ui/CDivider";

interface FormHeaderProps {
    title: string;
}

const FormHeader: React.FC<FormHeaderProps> = ({ title }) => {
    return (
        <Divider typeOf="primary" title={title} />
    )
}

export default FormHeader; 